import { UserRole } from '@app/domain/AccountUser'

export class CreateUserRequest {

    constructor(
        public name: string,
        public emailAddress?: string,
        public role?: UserRole,
        public password?: string,
    ) { }
}
